<template>
  <div class="teacher-home" v-loading="loading">
    <!-- 顶部统计：4 卡 -->
    <div class="stat-row">
      <div v-for="item in statCards" :key="item.key" class="stat-card">
        <div class="stat-card__content" :class="'stat-card--' + item.theme">
          <div class="stat-card__body">
            <div class="stat-card__label">{{ item.label }}</div>
            <div class="stat-card__value">
              {{ item.value
              }}<span class="stat-card__unit">{{ item.unit }}</span>
            </div>
            <!-- <div class="stat-card__trend">
              <div>
                <i v-if="Number(item.trend) >= 0" class="el-icon-top-right"></i>
                <i v-else class="el-icon-bottom-right"></i>
                {{ Number(item.trend) >= 0 ? "+" : "" }}{{ item.trend }}
              </div>
              <em>较上周</em>
            </div> -->
          </div>
          <img class="stat-card__icon" :src="item.iconImg" alt="" />
        </div>
      </div>
    </div>

    <!-- 中部：赛道 / 完成率 / 分布 / 排行 -->
    <el-row :gutter="16" class="panel-row">
      <el-col :xs="24" :sm="12" :lg="6">
        <div class="panel-card">
          <div class="panel-card__header">
            <div class="panel-card__title">
              <img class="title-icon" :src="imgs.titleJob" alt="" />
              课程赛道分布
            </div>
          </div>
          <div
            v-show="hasTrackData"
            ref="trackChart"
            class="chart-box chart-box--track"
          ></div>
          <div v-if="!hasTrackData" class="rank-empty">暂无赛道数据</div>
        </div>
      </el-col>

      <el-col :xs="24" :sm="12" :lg="6">
        <div class="panel-card">
          <div class="panel-card__header">
            <div class="panel-card__title">
              <img class="title-icon" :src="imgs.titlePath" alt="" />
              学习完成率
            </div>
          </div>
          <el-scrollbar class="panel-scroll">
            <div class="completion-list">
              <div
                v-for="(item, index) in completionList"
                :key="'completion-' + index"
                class="completion-list__item"
              >
                <div class="completion-list__meta">
                  <span class="completion-list__name" :title="item.name">{{
                    item.name
                  }}</span>
                  <span class="completion-list__pct">{{ item.percent }}%</span>
                </div>
                <div class="completion-list__track">
                  <div
                    class="completion-list__bar"
                    :style="{ width: item.percent + '%' }"
                  ></div>
                </div>
              </div>
              <div v-if="!completionList.length" class="rank-empty">
                暂无完成率数据
              </div>
            </div>
          </el-scrollbar>
        </div>
      </el-col>

      <el-col :xs="24" :sm="12" :lg="6">
        <div class="panel-card">
          <div class="panel-card__header">
            <div class="panel-card__title">
              <img class="title-icon" :src="imgs.titleGrowth" alt="" />
              课程分布
            </div>
          </div>
          <div ref="distChart" class="chart-box"></div>
        </div>
      </el-col>

      <el-col :xs="24" :sm="12" :lg="6">
        <div class="panel-card">
          <div class="panel-card__header">
            <div class="panel-card__title">
              <img class="title-icon" :src="imgs.titleRank" alt="" />
              课程排行榜
            </div>
          </div>
          <el-scrollbar class="panel-scroll">
            <div class="course-rank">
              <div
                v-for="(item, index) in courseRank"
                :key="'rank-' + index"
                class="course-rank__item"
              >
                <img
                  v-if="index < 3"
                  class="course-rank__badge"
                  :src="imgs.ranks[index]"
                  alt=""
                />
                <div v-else class="course-rank__no">{{ index + 1 }}</div>
                <div class="course-rank__main">
                  <div class="course-rank__name" :title="item.name">
                    {{ item.name }}
                  </div>
                  <el-progress
                    :percentage="item.percent"
                    :stroke-width="8"
                    :show-text="false"
                    color="#B949FF"
                  />
                </div>
                <div
                  class="course-rank__pct"
                  :title="'学习人次 ' + item.learnerCount"
                >
                  {{ item.learnerCount }}
                </div>
              </div>
              <div v-if="!courseRank.length" class="rank-empty">
                暂无排行数据
              </div>
            </div>
          </el-scrollbar>
        </div>
      </el-col>
    </el-row>

    <!-- 底部：增长 / 类型 / 月度活跃 -->
    <el-row :gutter="16" class="panel-row panel-row--bottom">
      <el-col :xs="24" :md="8">
        <div class="panel-card">
          <div class="panel-card__header">
            <div class="panel-card__title">
              <img class="title-icon" :src="imgs.titleGrowth" alt="" />
              学员增长趋势
            </div>
          </div>
          <div ref="growthChart" class="chart-box"></div>
        </div>
      </el-col>

      <el-col :xs="24" :md="8">
        <div class="panel-card">
          <div class="panel-card__header">
            <div class="panel-card__title">
              <img class="title-icon" :src="imgs.titleType" alt="" />
              课程类型
            </div>
          </div>
          <div class="panel-split panel-split--pie">
            <div ref="typeChart" class="chart-box chart-box--pie"></div>
            <div class="legend-list legend-list--type">
              <div
                v-for="(item, idx) in typeLegend"
                :key="'type-' + idx"
                class="legend-item legend-item--type"
              >
                <span
                  class="legend-swatch"
                  :style="{ background: item.color }"
                ></span>
                <span class="legend-name" :title="item.name">{{
                  item.name
                }}</span>
                <span class="legend-pct">{{ item.percent }}%</span>
              </div>
            </div>
          </div>
        </div>
      </el-col>

      <el-col :xs="24" :md="8">
        <div class="panel-card">
          <div class="panel-card__header">
            <div class="panel-card__title">
              <img class="title-icon" :src="imgs.titleHeat" alt="" />
              月度学习活跃热力图
            </div>
            <div class="calendar-nav">
              <el-date-picker
                v-model="calendarMonth"
                type="month"
                size="small"
                format="yyyy年MM月"
                placeholder="选择年月"
                :clearable="false"
                :editable="false"
                :picker-options="heatMonthPickerOptions"
                @change="onHeatMonthChange"
              />
            </div>
          </div>
          <div class="heat-calendar" v-loading="heatLoading">
            <div class="heat-calendar__weeks">
              <span v-for="w in weekLabels" :key="w">{{ w }}</span>
            </div>
            <div class="heat-calendar__days">
              <div
                v-for="(day, idx) in calendarDays"
                :key="idx"
                class="heat-day"
                :class="{
                  'is-empty': !day.date,
                  'is-today': day.isToday
                }"
                :style="day.date ? heatDayStyle(day.count) : null"
                :title="day.date ? `${day.date}日 · ${day.count} 人` : ''"
              >
                <span v-if="day.date" class="heat-day__count">{{
                  day.count
                }}</span>
              </div>
            </div>
            <div class="heat-calendar__legend">
              <span>低</span>
              <i
                v-for="(lv, i) in heatLegendDots"
                :key="'hl-' + i"
                class="heat-dot"
                :style="{ background: lv.bg }"
              ></i>
              <span>高</span>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {
  getTeacherOverview,
  getTeacherCourseTrack,
  getTeacherLearningCompletion,
  getTeacherCourseDistribution,
  getTeacherCourseRanking,
  getTeacherStudentGrowth,
  getTeacherCourseType,
  getTeacherDailyActive
} from "@/api/home";
import { ensureDictCache, getDictLabel, DICT_TYPE } from "@/utils/dict";

const TRACK_COLORS = [
  "#A78BFA",
  "#818CF8",
  "#FBBF24",
  "#A3E635",
  "#2DD4BF",
  "#38BDF8"
];
const TYPE_COLORS = [
  "#F43F5E",
  "#FB923C",
  "#38BDF8",
  "#22C55E",
  "#A78BFA",
  "#F59E0B"
];

const HEAT_LEVELS = [
  { max: 0, bg: "#F1F5F9", color: "#94A3B8" },
  { max: 20, bg: "#BBF7D0", color: "#166534" },
  { max: 40, bg: "#86EFAC", color: "#14532D" },
  { max: 60, bg: "#FDBA74", color: "#9A3412" },
  { max: 80, bg: "#FB923C", color: "#FFFFFF" },
  { max: Infinity, bg: "#EF4444", color: "#FFFFFF" }
];

const WEEK_LABELS = ["周一", "周二", "周三", "周四", "周五", "周六", "周日"];

function unwrapData(res) {
  if (!res) return null;
  if (res.data !== undefined) return res.data;
  return res;
}

function normalizeList(list) {
  if (!list) return [];
  if (Array.isArray(list)) return list;
  if (Array.isArray(list.rows)) return list.rows;
  if (Array.isArray(list.list)) return list.list;
  return [];
}

function toFiniteNumber(val, fallback = 0) {
  const n = Number(val);
  return Number.isFinite(n) ? n : fallback;
}

function formatNumber(val) {
  if (val === null || val === undefined || val === "") return "0";
  const num = Number(val);
  if (!Number.isFinite(num)) return String(val);
  return num.toLocaleString("zh-CN");
}

function formatDateLabel(dateStr) {
  if (!dateStr) return "";
  const parts = String(dateStr).split("-");
  if (parts.length >= 3) {
    return `${Number(parts[1])}/${Number(parts[2])}`;
  }
  return dateStr;
}

export default {
  name: "Home",
  data() {
    return {
      loading: false,
      imgs: {
        iconUp: require("@/assets/img/home/dash-icon-up.png"),
        titleGrowth: require("@/assets/img/home/dash-title-growth.png"),
        titleJob: require("@/assets/img/home/dash-title-job.png"),
        titleRank: require("@/assets/img/home/dash-title-rank.png"),
        titlePath: require("@/assets/img/home/dash-title-path.png"),
        titleType: require("@/assets/img/home/dash-title-type.png"),
        titleHeat: require("@/assets/img/home/dash-title-heat.png"),
        ranks: [
          require("@/assets/img/home/rank-1.png"),
          require("@/assets/img/home/rank-2.png"),
          require("@/assets/img/home/rank-3.png")
        ]
      },
      weekLabels: WEEK_LABELS,
      statCards: [
        {
          key: "students",
          label: "学员总数",
          value: "0",
          unit: "人",
          trend: 0,
          theme: "purple",
          iconImg: require("@/assets/img/home/dash-stat-students.png")
        },
        {
          key: "courses",
          label: "课程总数",
          value: "0",
          unit: "门",
          trend: 0,
          theme: "green",
          iconImg: require("@/assets/img/home/dash-stat-courses.png")
        },
        {
          key: "duration",
          label: "平均学习时长",
          value: "0",
          unit: "分钟",
          trend: 0,
          theme: "orange",
          iconImg: require("@/assets/img/home/dash-stat-duration.png")
        },
        {
          key: "today",
          label: "今日学习人次",
          value: "0",
          unit: "人",
          trend: 0,
          theme: "pink",
          iconImg: require("@/assets/img/home/dash-stat-today.png")
        }
      ],
      trackLegend: [],
      typeLegend: [],
      typeTotalCount: 0,
      courseRank: [],
      completionList: [],
      distLabels: [],
      distValues: [],
      growthLabels: [],
      growthValues: [],
      heatMap: {},
      heatLevels: HEAT_LEVELS,
      heatLoading: false,
      /** 每日活跃原始列表，切换月份时本地过滤 */
      dailyActiveCache: [],
      calendarMonth: new Date(),
      heatMonthPickerOptions: {
        disabledDate(time) {
          const now = new Date();
          const end = new Date(now.getFullYear(), now.getMonth() + 1, 1);
          return time.getTime() >= end.getTime();
        }
      },
      trackChart: null,
      distChart: null,
      growthChart: null,
      typeChart: null
    };
  },
  computed: {
    heatLegendDots() {
      return (this.heatLevels || HEAT_LEVELS).slice(1);
    },
    /** 赛道饼图：至少有一项 courseCount > 0 才绘制 */
    hasTrackData() {
      return (this.trackLegend || []).some(item => Number(item.value) > 0);
    },
    calendarDays() {
      const monthDate =
        this.calendarMonth instanceof Date
          ? this.calendarMonth
          : new Date(this.calendarMonth);
      if (Number.isNaN(monthDate.getTime())) return [];
      const year = monthDate.getFullYear();
      const month = monthDate.getMonth();
      const firstWeekday = new Date(year, month, 1).getDay();
      const offset = firstWeekday === 0 ? 6 : firstWeekday - 1;
      const daysInMonth = new Date(year, month + 1, 0).getDate();
      const today = new Date();
      const list = [];
      for (let i = 0; i < offset; i++) list.push({ date: null });
      for (let d = 1; d <= daysInMonth; d++) {
        const key = `${year}-${String(month + 1).padStart(2, "0")}-${String(
          d
        ).padStart(2, "0")}`;
        list.push({
          date: d,
          count: Number(this.heatMap[key]) || 0,
          isToday:
            today.getFullYear() === year &&
            today.getMonth() === month &&
            today.getDate() === d
        });
      }
      return list;
    }
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
    this.bootstrap();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
    [this.trackChart, this.distChart, this.growthChart, this.typeChart].forEach(
      chart => chart && chart.dispose()
    );
  },
  methods: {
    async bootstrap() {
      this.loading = true;
      try {
        await this.fetchDashboard();
        await this.$nextTick();
        this.initAllCharts();
        this.handleResize();
      } finally {
        this.loading = false;
      }
    },
    async fetchDashboard() {
      await ensureDictCache(DICT_TYPE.COURSE_TYPE).catch(() => null);
      await Promise.all([
        ensureDictCache(DICT_TYPE.LEARNING_SYSTEM).catch(() => null),
        ensureDictCache(DICT_TYPE.LEARNING_PATH).catch(() => null)
      ]);
      const [
        overviewRes,
        trackRes,
        completionRes,
        distRes,
        rankRes,
        growthRes,
        typeRes,
        activeRes
      ] = await Promise.all([
        getTeacherOverview().catch(() => null),
        getTeacherCourseTrack().catch(() => null),
        getTeacherLearningCompletion().catch(() => null),
        getTeacherCourseDistribution().catch(() => null),
        getTeacherCourseRanking().catch(() => null),
        getTeacherStudentGrowth({ days: 7 }).catch(() => null),
        getTeacherCourseType().catch(() => null),
        getTeacherDailyActive().catch(() => null)
      ]);

      this.applyOverview(unwrapData(overviewRes));
      this.applyTrack(unwrapData(trackRes));
      this.applyCompletion(unwrapData(completionRes));
      this.applyDistribution(unwrapData(distRes));
      this.applyRanking(unwrapData(rankRes));
      this.applyGrowth(unwrapData(growthRes));
      this.applyCourseType(unwrapData(typeRes));

      this.dailyActiveCache = normalizeList(unwrapData(activeRes));
      this.applyHeatFromDailyActive();
    },
    applyOverview(data) {
      const emptyCards = {
        students: { value: "0", trend: 0 },
        courses: { value: "0", trend: 0 },
        duration: { value: "0", trend: 0 },
        today: { value: "0", trend: 0 }
      };
      if (!data || typeof data !== "object") {
        this.statCards = this.statCards.map(card => {
          const patch = emptyCards[card.key];
          return patch ? { ...card, ...patch } : card;
        });
        return;
      }
      // 教师统计概览：接口原样；trend 缺省默认 0
      const week = val =>
        val === null || val === undefined || val === "" ? 0 : val;
      const map = {
        students: {
          value: formatNumber(data.memberCount),
          trend: week(data.memberCountWeekIncrease)
        },
        courses: {
          value: formatNumber(data.courseCount),
          trend: week(data.courseCountWeekIncrease)
        },
        duration: {
          value: formatNumber(data.avgStudyMinutes),
          trend: week(data.avgStudyMinutesWeekIncrease)
        },
        today: {
          value: formatNumber(data.todayStudyCount),
          trend: week(data.todayStudyCountWeekIncrease)
        }
      };
      this.statCards = this.statCards.map(card => {
        const patch = map[card.key];
        return patch ? { ...card, ...patch } : card;
      });
    },
    applyTrack(list) {
      // courseTrack：数量为 0 的项不进入图例/绘图
      const raw = normalizeList(list);
      const rows = raw
        .map((item, i) => ({
          name:
            item.learningSystemName ||
            item.learningPathName ||
            getDictLabel(DICT_TYPE.LEARNING_SYSTEM, item.learningSystemType) ||
            getDictLabel(DICT_TYPE.LEARNING_PATH, item.learningPath) ||
            "-",
          value: toFiniteNumber(item.courseCount, 0),
          color: TRACK_COLORS[i % TRACK_COLORS.length]
        }))
        .filter(item => item.value > 0);
      const total = rows.reduce((s, item) => s + item.value, 0);
      this.trackLegend = rows.map(item => ({
        ...item,
        percent: total > 0 ? Math.round((item.value / total) * 10000) / 100 : 0
      }));
    },
    applyCompletion(list) {
      // learningCompletion：courseName + completionRate
      const rows = normalizeList(list);
      this.completionList = rows.map(item => {
        const rate = toFiniteNumber(item.completionRate, 0);
        const percent = Math.max(
          0,
          Math.min(100, Math.round(rate * 100) / 100)
        );
        return {
          name: item.courseName || item.courseCode || "-",
          percent
        };
      });
    },
    applyDistribution(list) {
      // courseDistribution：learningSystemName + courseCount
      const rows = normalizeList(list);
      this.distLabels = rows.map(
        item =>
          item.learningSystemName ||
          (item.learningSystemType != null
            ? String(item.learningSystemType)
            : "-")
      );
      this.distValues = rows.map(item => toFiniteNumber(item.courseCount, 0));
    },
    applyRanking(list) {
      // courseRanking：按 learnerCount 相对最大值作为进度条；右侧展示学习人次
      const rows = normalizeList(list);
      const maxStudy = Math.max(
        0,
        ...rows.map(item => toFiniteNumber(item.learnerCount, 0))
      );
      this.courseRank = rows.map(item => {
        const learnerCount = toFiniteNumber(item.learnerCount, 0);
        return {
          name: item.courseName || item.courseCode || "-",
          learnerCount,
          percent:
            maxStudy > 0 ? Math.round((learnerCount / maxStudy) * 100) : 0
        };
      });
    },
    applyGrowth(list) {
      // studentGrowth：date(yyyy-MM-dd) + newMemberCount
      const rows = normalizeList(list);
      this.growthLabels = rows.map(item => formatDateLabel(item.date));
      this.growthValues = rows.map(item =>
        toFiniteNumber(item.newMemberCount, 0)
      );
    },
    applyCourseType(list) {
      // courseType：数量为 0 的项不进入图例/绘图
      const raw = normalizeList(list);
      const rows = raw
        .map((item, i) => ({
          name:
            getDictLabel(DICT_TYPE.COURSE_TYPE, item.courseType) ||
            (item.courseType != null ? String(item.courseType) : "-"),
          value: toFiniteNumber(item.count, 0),
          color: TYPE_COLORS[i % TYPE_COLORS.length]
        }))
        .filter(item => item.value > 0);
      const total = rows.reduce((s, item) => s + item.value, 0);
      this.typeLegend = rows.map(item => ({
        ...item,
        percent: total > 0 ? Math.round((item.value / total) * 10000) / 100 : 0
      }));
      this.typeTotalCount = total;
    },
    applyHeatFromDailyActive() {
      // dailyActive：date + activeMemberCount → 按选中年月过滤
      const monthDate =
        this.calendarMonth instanceof Date
          ? this.calendarMonth
          : new Date(this.calendarMonth);
      if (Number.isNaN(monthDate.getTime())) return;
      const year = monthDate.getFullYear();
      const month = monthDate.getMonth() + 1;
      const prefix = `${year}-${String(month).padStart(2, "0")}-`;
      const list = (this.dailyActiveCache || [])
        .filter(item => item && String(item.date || "").startsWith(prefix))
        .map(item => {
          const day = Number(String(item.date).slice(-2));
          return {
            day,
            count: toFiniteNumber(item.activeMemberCount, 0)
          };
        })
        .filter(item => item.day >= 1);
      this.applyHeatData(list);
    },
    applyHeatData(list) {
      const monthDate =
        this.calendarMonth instanceof Date
          ? this.calendarMonth
          : new Date(this.calendarMonth);
      const year = monthDate.getFullYear();
      const month = monthDate.getMonth();
      const daysInMonth = new Date(year, month + 1, 0).getDate();
      const map = {};
      let maxCount = 0;
      for (let d = 1; d <= daysInMonth; d++) {
        const key = `${year}-${String(month + 1).padStart(2, "0")}-${String(
          d
        ).padStart(2, "0")}`;
        map[key] = 0;
      }
      normalizeList(list).forEach(item => {
        const day = toFiniteNumber(item && item.day, 0);
        if (!day || day < 1 || day > daysInMonth) return;
        const key = `${year}-${String(month + 1).padStart(2, "0")}-${String(
          day
        ).padStart(2, "0")}`;
        const count = toFiniteNumber(item.count, 0);
        map[key] = count;
        if (count > maxCount) maxCount = count;
      });
      this.heatMap = map;
      if (maxCount > 0) {
        const step = Math.max(1, Math.ceil(maxCount / 5));
        this.heatLevels = [
          { max: 0, bg: "#F1F5F9", color: "#94A3B8" },
          { max: step, bg: "#BBF7D0", color: "#166534" },
          { max: step * 2, bg: "#86EFAC", color: "#14532D" },
          { max: step * 3, bg: "#FDBA74", color: "#9A3412" },
          { max: step * 4, bg: "#FB923C", color: "#FFFFFF" },
          { max: Infinity, bg: "#EF4444", color: "#FFFFFF" }
        ];
      } else {
        this.heatLevels = HEAT_LEVELS;
      }
    },
    async onHeatMonthChange(val) {
      if (!val) {
        this.calendarMonth = new Date();
      } else if (!(val instanceof Date)) {
        this.calendarMonth = new Date(val);
      }
      await this.loadHeatmap();
    },
    async loadHeatmap() {
      const monthDate =
        this.calendarMonth instanceof Date
          ? this.calendarMonth
          : new Date(this.calendarMonth);
      if (Number.isNaN(monthDate.getTime())) return;
      this.calendarMonth = monthDate;
      this.heatLoading = true;
      try {
        const heatRes = await getTeacherDailyActive().catch(() => null);
        this.dailyActiveCache = normalizeList(unwrapData(heatRes));
        this.applyHeatFromDailyActive();
      } finally {
        this.heatLoading = false;
      }
    },
    heatDayStyle(count) {
      const n = Number(count) || 0;
      const levels = this.heatLevels || HEAT_LEVELS;
      const level =
        levels.find(item => n <= item.max) || levels[levels.length - 1];
      return {
        backgroundColor: level.bg,
        color: level.color
      };
    },
    initAllCharts() {
      this.initTrackChart();
      this.initDistChart();
      this.initGrowthChart();
      this.initTypeChart();
    },
    handleResize() {
      [
        this.trackChart,
        this.distChart,
        this.growthChart,
        this.typeChart
      ].forEach(c => c && c.resize());
    },
    hexToRgba(hex, alpha) {
      const raw = String(hex || "").replace("#", "");
      if (raw.length !== 6) return `rgba(148, 163, 184, ${alpha})`;
      const r = parseInt(raw.slice(0, 2), 16);
      const g = parseInt(raw.slice(2, 4), 16);
      const b = parseInt(raw.slice(4, 6), 16);
      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    },
    initTrackChart() {
      if (!this.$refs.trackChart) return;
      if (!this.hasTrackData) {
        if (this.trackChart) {
          this.trackChart.clear();
        }
        return;
      }
      if (!this.trackChart) {
        this.trackChart = this.$echarts.init(this.$refs.trackChart);
      }
      const legend = this.trackLegend || [];
      const visible = legend.filter(item => item.value > 0);
      const total = visible.reduce((s, item) => s + Number(item.value || 0), 0);
      let acc = 0;
      const ellipsisName = (name, max = 6) => {
        const text = String(name || "-");
        return text.length > max ? `${text.slice(0, max)}…` : text;
      };
      const data = visible.map(item => {
        const value = Number(item.value || 0);
        const sweep = total > 0 ? (value / total) * 360 : 0;
        // echarts pie 默认 startAngle=90、顺时针
        const mid = (90 - acc - sweep / 2 + 360) % 360;
        acc += sweep;
        const distToTop = Math.min(Math.abs(mid - 90), Math.abs(mid - 450));
        const distToBottom = Math.abs(mid - 270);
        const nearVertical = Math.min(distToTop, distToBottom) < 40;
        const pct =
          item.percent != null && item.percent !== ""
            ? Number(item.percent)
            : null;
        const pctText = Number.isFinite(pct)
          ? `${Math.round(pct * 100) / 100}%`
          : "-";
        const fullName = item.name || "-";
        const shortName = ellipsisName(fullName);
        return {
          name: fullName,
          value,
          itemStyle: { color: item.color },
          label: {
            show: true,
            formatter: `{dot|●} {name|${shortName}}\n{pct|${pctText}}`,
            rich: {
              dot: {
                color: item.color,
                fontSize: 10,
                padding: [0, 2, 0, 0]
              },
              name: {
                color: "#4B5563",
                fontSize: 12,
                fontWeight: 500,
                lineHeight: 16
              },
              pct: {
                color: "#6B7280",
                fontSize: 12,
                lineHeight: 16,
                padding: [0, 0, 0, 12]
              }
            }
          },
          labelLine: {
            show: true,
            length: nearVertical ? 4 : 8,
            length2: nearVertical ? 4 : 10,
            lineStyle: {
              color: "#D1D5DB",
              width: 1
            }
          }
        };
      });
      this.trackChart.setOption(
        {
          tooltip: {
            trigger: "item",
            formatter: params => {
              const row = visible[params.dataIndex] || {};
              const pct =
                row.percent != null
                  ? row.percent
                  : params.percent != null
                  ? Math.round(params.percent * 100) / 100
                  : "-";
              return `${params.name}<br/>占比：${pct}%`;
            }
          },
          series: [
            {
              name: "赛道",
              type: "pie",
              radius: ["36%", "68%"],
              center: ["50%", "50%"],
              avoidLabelOverlap: true,
              minShowLabelAngle: 0,
              label: {
                position: "outside"
              },
              data,
              itemStyle: {
                borderColor: "#fff",
                borderWidth: 2
              }
            }
          ],
          graphic: [
            {
              type: "text",
              left: "center",
              top: "44%",
              style: {
                text: "课程",
                textAlign: "center",
                fill: "#0F74FF",
                fontSize: 18,
                fontWeight: 600
              }
            },
            {
              type: "text",
              left: "center",
              top: "52%",
              style: {
                text: "赛道",
                textAlign: "center",
                fill: "#0F74FF",
                fontSize: 18,
                fontWeight: 600
              }
            }
          ]
        },
        true
      );
    },
    initDistChart() {
      if (!this.$refs.distChart) return;
      if (!this.distChart) {
        this.distChart = this.$echarts.init(this.$refs.distChart);
      }
      const labels = this.distLabels || [];
      const values = this.distValues || [];
      // 全为 0 时仍保留 X 轴分类，并给 Y 轴一个最小刻度，避免坐标轴被压扁
      const maxVal = Math.max.apply(null, [0].concat(values));
      const yMax = maxVal > 0 ? Math.ceil(maxVal * 1.2) || 1 : 1;
      this.distChart.setOption(
        {
          color: ["#F59E0B"],
          tooltip: {
            trigger: "axis",
            backgroundColor: "rgba(255,255,255,0.96)",
            borderColor: "#e5e6eb",
            borderWidth: 1,
            textStyle: { color: "#4e5969", fontSize: 12 }
          },
          grid: { left: 40, right: 12, top: 24, bottom: 40 },
          xAxis: {
            type: "category",
            data: labels,
            show: true,
            axisLine: { show: true, lineStyle: { color: "#e5e6eb" } },
            axisTick: { show: false },
            axisLabel: {
              show: true,
              color: "#86909c",
              interval: 0,
              fontSize: 11,
              rotate: 20
            }
          },
          yAxis: {
            type: "value",
            min: 0,
            max: yMax,
            axisLine: { show: false },
            axisTick: { show: false },
            splitLine: { lineStyle: { color: "#f0f2f5", type: "dashed" } },
            axisLabel: { color: "#86909c" }
          },
          series: [
            {
              name: "课程数",
              type: "bar",
              barWidth: 16,
              data: values,
              itemStyle: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    { offset: 0, color: "#F59E0B" },
                    { offset: 1, color: "#FCD34D" }
                  ]
                },
                barBorderRadius: [6, 6, 0, 0]
              }
            }
          ]
        },
        true
      );
    },
    initGrowthChart() {
      if (!this.$refs.growthChart) return;
      if (!this.growthChart) {
        this.growthChart = this.$echarts.init(this.$refs.growthChart);
      }
      const echarts = this.$echarts;
      const values = this.growthValues || [];
      const maxVal = Math.max.apply(null, [0].concat(values));
      const yMax = maxVal > 0 ? Math.ceil(maxVal * 1.4) || 1 : 1;
      this.growthChart.setOption(
        {
          color: ["#5B9CFF"],
          grid: { left: 36, right: 16, top: 28, bottom: 28 },
          tooltip: {
            trigger: "axis",
            backgroundColor: "#fff",
            borderColor: "#e8edf5",
            borderWidth: 1,
            padding: [10, 14],
            textStyle: { color: "#606266", fontSize: 12 },
            extraCssText:
              "box-shadow: 0 6px 18px rgba(28, 104, 255, 0.12); border-radius: 8px;",
            formatter: params => {
              const p = params && params[0];
              if (!p) return "";
              return [
                `<div style="color:#909399;margin-bottom:6px;">${p.axisValue}</div>`,
                `<div style="color:#3B82F6;font-weight:600;">新增学员 ${p.value}人</div>`
              ].join("");
            }
          },
          xAxis: {
            type: "category",
            boundaryGap: false,
            data: this.growthLabels,
            axisLine: { show: false },
            axisTick: { show: false },
            axisLabel: { color: "#A0A7B3", fontSize: 12 },
            splitLine: {
              show: true,
              lineStyle: { color: "#E8EDF5", type: "dashed" }
            }
          },
          yAxis: {
            type: "value",
            min: 0,
            max: yMax,
            axisLine: { show: false },
            axisTick: { show: false },
            axisLabel: { color: "#A0A7B3", fontSize: 12 },
            splitLine: {
              lineStyle: { color: "#E8EDF5", type: "dashed" }
            }
          },
          series: [
            {
              type: "line",
              smooth: true,
              symbol: "circle",
              symbolSize: 8,
              showSymbol: true,
              itemStyle: {
                color: "rgba(0, 161, 255, 1)",
                borderColor: "#fff",
                borderWidth: 2
              },
              lineStyle: {
                width: 3,
                color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                  { offset: 0, color: "rgba(17, 239, 255, 0)" },
                  { offset: 0.25, color: "rgba(17, 239, 255, 1)" },
                  { offset: 0.5, color: "rgba(56, 209, 255, 1)" },
                  { offset: 0.75, color: "rgba(0, 161, 255, 1)" },
                  { offset: 1, color: "rgba(54, 181, 247, 0)" }
                ])
              },
              areaStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                  { offset: 0, color: "rgba(17, 239, 255, 0)" },
                  { offset: 0.25, color: "rgba(17, 239, 255, 0.28)" },
                  { offset: 0.5, color: "rgba(56, 209, 255, 0.25)" },
                  { offset: 0.75, color: "rgba(0, 161, 255, 0.22)" },
                  { offset: 1, color: "rgba(54, 181, 247, 0)" }
                ])
              },
              data: values
            }
          ]
        },
        true
      );
    },
    initTypeChart() {
      if (!this.$refs.typeChart) return;
      if (!this.typeChart) {
        this.typeChart = this.$echarts.init(this.$refs.typeChart);
      }
      const total =
        this.typeTotalCount ||
        this.typeLegend.reduce((s, i) => s + Number(i.value || 0), 0);
      const data = this.typeLegend.map(item => ({
        name: item.name,
        value: item.value,
        itemStyle: { color: item.color }
      }));
      const outerTrack = this.typeLegend.map(item => ({
        name: item.name,
        value: item.value,
        itemStyle: { color: this.hexToRgba(item.color, 0.4) }
      }));
      this.typeChart.setOption(
        {
          tooltip: { trigger: "item", formatter: "{b}: {c} ({d}%)" },
          series: [
            {
              name: "外圈",
              type: "pie",
              radius: ["75%", "85%"],
              center: ["50%", "50%"],
              silent: true,
              z: 1,
              label: { show: false },
              labelLine: { show: false },
              itemStyle: { borderColor: "#fff", borderWidth: 2 },
              data
            },
            {
              name: "类型",
              type: "pie",
              radius: ["40%", "75%"],
              center: ["50%", "50%"],
              z: 2,
              label: { show: false },
              labelLine: { show: false },
              itemStyle: { borderColor: "#fff", borderWidth: 2 },
              data: outerTrack
            }
          ],
          graphic: [
            {
              type: "text",
              left: "center",
              top: "40%",
              style: {
                text: String(total),
                textAlign: "center",
                fill: "#3B82F6",
                fontSize: 26,
                fontWeight: 700
              }
            },
            {
              type: "text",
              left: "center",
              top: "56%",
              style: {
                text: "课程总数",
                textAlign: "center",
                fill: "#94A3B8",
                fontSize: 12
              }
            }
          ]
        },
        true
      );
    }
  }
};
</script>

<style scoped lang="less">
.teacher-home {
  min-height: 100%;
}

.stat-row {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 14px;
  margin-bottom: 16px;
}

.stat-card {
  position: relative;
  color: #90a1b9;
  border-radius: 14px;
  background: #fff;

  &__content {
    display: flex;
    box-shadow: 0 8px 24px rgba(59, 130, 246, 0.12);
    padding: 0 18px;
    height: 170px;
    align-items: center;
    justify-content: space-between;
    border-top: 5px solid;
    border-radius: 14px;
  }

  &--purple {
    background: linear-gradient(180deg, #ecf4ff 0%, #ffffff 100%);
    border-color: #005ffd;
    .stat-card__trend {
      div {
        background: rgba(99, 153, 241, 0.07);
        color: #6399f1;
      }
    }
  }
  &--green {
    border-color: #30ca88;
    background: linear-gradient(180deg, #f1fff9 0%, #ffffff 100%);
    .stat-card__trend {
      div {
        background: rgba(16, 185, 129, 0.07);
        color: #10b981;
      }
    }
  }
  &--orange {
    border-color: #fd9418;
    background: linear-gradient(180deg, #fffdfa 0%, #ffffff 100%);
    .stat-card__trend {
      div {
        background: rgba(245, 158, 11, 0.07);
        color: #f59e0b;
      }
    }
  }
  &--pink {
    border-color: #f9478a;
    background: linear-gradient(180deg, #fff1f8 0%, #ffffff 100%);
    .stat-card__trend {
      div {
        background: rgba(239, 68, 68, 0.07);
        color: #ef4444;
      }
    }
  }

  &__label {
    font-size: 18px;
    margin-bottom: 8px;
    color: #67778d;
  }

  &__value {
    font-size: 38px;
    font-weight: 700;
    line-height: 1.15;
    color: #1b294b;
    padding-bottom: 12px;
    border-bottom: 1px solid rgba(99, 153, 241, 0.2);
  }

  &__unit {
    font-size: 14px;
    font-weight: 500;
    margin-left: 2px;
    color: #67778d;
  }

  &__trend {
    margin-top: 10px;
    display: flex;
    align-items: center;
    gap: 12px;
    font-size: 14px;
    line-height: 18px;
    div {
      border-radius: 9px;
      padding: 0 10px;
      display: inline-flex;
      align-items: center;
      gap: 2px;
    }
    i {
      font-size: 12px;
    }
    em {
      font-style: normal;
      opacity: 0.85;
      color: #94b0b8;
      margin-left: 2px;
    }
  }

  &__icon {
    width: 100px;
    object-fit: contain;
    flex-shrink: 0;
    filter: drop-shadow(0 8px 12px rgba(0, 0, 0, 0.12));
  }
}

.panel-row {
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;

  /deep/ .el-col {
    display: flex;
    margin-bottom: 16px;
    float: none;
    > .panel-card {
      width: 100%;
      flex: 1 1 auto;
      align-self: stretch;
    }
  }

  /* 中部四卡等高，列表区域内部滚动 */
  &:not(.panel-row--bottom) {
    /deep/ .el-col > .panel-card {
      height: 380px;
      overflow: hidden;
    }
  }

  &--bottom {
    /deep/ .el-col > .panel-card {
      min-height: 0;
      height: auto;
      overflow: visible;
    }
  }
}

.panel-card {
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 16px;
  padding: 16px 18px 12px;
  box-shadow: 0 2px 14px rgba(15, 35, 95, 0.05);
  min-height: 320px;
  box-sizing: border-box;
  overflow: visible;

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;
  }

  &__title {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 16px;
    font-weight: 600;
    color: #1e1b4b;
  }
}

.calendar-nav {
  font-size: 13px;
  color: #64748b;

  /deep/ .el-date-editor.el-input {
    width: 132px;
  }

  /deep/ .el-input__inner {
    height: 30px;
    line-height: 30px;
    border-radius: 8px;
    border-color: #dbe7f7;
    color: #334155;
    font-size: 13px;
    padding-left: 28px;
    padding-right: 8px;
    background: #f8fbff;
  }

  /deep/ .el-input__prefix {
    left: 6px;
  }

  /deep/ .el-input__icon {
    line-height: 30px;
  }
}

.title-icon {
  width: 36px;
  height: 36px;
  object-fit: contain;
  border-radius: 10px;
}

.chart-box {
  width: 100%;
  flex: 1;
  min-height: 240px;

  &--pie {
    width: 48%;
    flex: 0 0 48%;
    max-width: 48%;
    min-height: 200px;
    height: 100%;
  }

  &--track {
    width: 100%;
    flex: 1;
    min-height: 0;
    height: auto;
  }
}

.panel-split {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 0;

  &--pie {
    gap: 4px 10px;
    align-items: center;

    .legend-list {
      width: 52%;
      flex: 0 0 52%;
      max-width: 52%;
    }
  }
}

.legend-list {
  flex: 1;
  min-width: 0;
  overflow: visible;

  &--job {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    column-gap: 8px;
    row-gap: 14px;
    align-content: center;
  }

  &--type {
    display: flex;
    flex-direction: column;
    gap: 10px;
    justify-content: center;
  }
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 0;
  font-size: 13px;
  color: #374151;
  min-width: 0;

  &--type {
    gap: 16px;
    padding-left: 12px;
  }
}

.legend-meta {
  flex: 1;
  min-width: 0;
}

.legend-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

.legend-swatch {
  width: 18px;
  height: 12px;
  border-radius: 4px;
  flex-shrink: 0;
}

.legend-name {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #334155;
}

.legend-pct {
  flex-shrink: 0;
  color: #374151;
}

.panel-scroll {
  flex: 1;
  min-height: 0;
  height: 100%;

  /deep/ .el-scrollbar__wrap {
    overflow-x: hidden;
  }

  /deep/ .el-scrollbar__bar.is-vertical {
    width: 4px;
    right: 2px;
  }

  /deep/ .el-scrollbar__thumb {
    background-color: rgba(144, 147, 153, 0.35);
    border-radius: 999px;
  }
}

.course-rank {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 4px 8px 8px 0;

  &__item {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  &__badge {
    width: 26px;
    height: 36px;
    object-fit: contain;
    flex-shrink: 0;
  }

  &__no {
    width: 26px;
    height: 26px;
    border-radius: 6px;
    background: #f2f3f5;
    color: #67778d;
    font-size: 12px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  &__main {
    flex: 1;
    min-width: 0;
  }

  &__name {
    font-size: 13px;
    color: #1b294b;
    font-weight: 600;
    margin-bottom: 6px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &__pct {
    flex-shrink: 0;
    font-size: 13px;
    font-weight: 600;
    color: #7c3aed;
    min-width: 42px;
    text-align: right;
  }
}

.completion-list {
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 4px 8px 8px 2px;

  &__item {
    flex-shrink: 0;
  }

  &__meta {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 8px;
  }

  &__name {
    flex: 1;
    min-width: 0;
    font-size: 13px;
    font-weight: 600;
    color: #1b294b;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &__pct {
    flex-shrink: 0;
    font-size: 13px;
    color: #8a94a6;
    font-weight: 500;
  }

  &__track {
    height: 10px;
    border-radius: 999px;
    background: #f2f7ff;
    overflow: hidden;
  }

  &__bar {
    height: 100%;
    border-radius: 999px;
    background: linear-gradient(270deg, #8dbeff 0%, #2b84ff 100%);
    min-width: 0;
    transition: width 0.3s ease;
  }
}

.rank-empty {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #86909c;
  font-size: 13px;
}

.heat-calendar {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: visible;

  &__weeks,
  &__days {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 6px;
    text-align: center;
  }

  &__weeks {
    margin-bottom: 8px;
    font-size: 12px;
    font-weight: 600;
    color: #64748b;
  }

  &__legend {
    margin-top: auto;
    padding-top: 12px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 4px;
    font-size: 12px;
    color: #94a3b8;
  }
}

.heat-day {
  min-height: 28px;
  height: 28px;
  border-radius: 6px;
  background: #f1f5f9;
  color: #334155;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 2px;
  box-sizing: border-box;

  &.is-empty {
    visibility: hidden;
  }

  &.is-today {
    box-shadow: inset 0 0 0 2px #3b82f6;
  }

  &__count {
    font-size: 12px;
    font-weight: 700;
    line-height: 1;
  }
}

.heat-dot {
  width: 12px;
  height: 12px;
  border-radius: 3px;
  display: inline-block;
}

@media (max-width: 1200px) {
  .stat-row {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/index.vue